import * as React from 'react';

import PropTypes from 'prop-types';

export class FunnelNumberLabel extends React.Component {
    static percentOfMax;

    static propTypes = {
        json: PropTypes.shape({
            count: PropTypes.shape({
                formatted: PropTypes.string.isRequired,
                suffix: PropTypes.string,
                value: PropTypes.number.isRequired,
            }).isRequired,
            amount: PropTypes.shape({
                value: PropTypes.number.isRequired,
                formatted: PropTypes.string.isRequired,
                suffix: PropTypes.string,
                prefix: PropTypes.string,
            }).isRequired,
            htmlUrl: PropTypes.string,
        }).isRequired,
        isInline: PropTypes.bool,
        isBlank: PropTypes.bool.isRequired,
        displayType: PropTypes.oneOf(['count', 'amount']),
    };

    static defaultProps = {
        isInline: false,
    };

    render() {
        let label;
        const {
            count: {formatted: count, value: rawCountValue, suffix: countSuffix},
            amount: {
                value: rawAmountValue,
                formatted: amount,
                suffix: amountSuffix,
                prefix: currencySymbol,
            },
        } = this.props.json;

        if (this.props.displayType === 'count') {
            label = (
                <div
                    className='ui-funnel-number-label__container'
                    style={this.props.isInline ? {display: 'inline'} : null}
                    title={rawCountValue.toLocaleString()}
                >
                    <span className='ui-funnel-number-label__primary-text'>{count}</span>
                    {countSuffix ? (
                        <span className='ui-funnel-number-label__primary-text'>{countSuffix}</span>
                    ) : (
                        <span />
                    )}
                </div>
            );
        } else {
            label = (
                <div
                    className='ui-funnel-number-label__container'
                    style={this.props.isInline ? {display: 'inline'} : null}
                    title={rawAmountValue.toLocaleString()}
                >
                    <span className='ui-funnel-number-label__secondary-text'>{currencySymbol}</span>
                    <span className='ui-funnel-number-label__primary-text'>{amount}</span>
                    {amountSuffix ? (
                        <span className='ui-funnel-number-label__primary-text'>{amountSuffix}</span>
                    ) : (
                        <span />
                    )}
                </div>
            );
        }

        if (this.props.isBlank) {
            return <div />;
        }

        return label;
    }
}
